import { render, staticRenderFns } from "./photo_manager.vue?vue&type=template&id=7796b98f&"
import script from "./photo_manager.vue?vue&type=script&lang=js&"
export * from "./photo_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports